import { useMemo } from 'react';
import Cookies from 'js-cookie';

export function useShowOfferPage(): boolean {
  const throughReseller = Cookies.get('throughReseller');
  const throughCampaign = Cookies.get('throughCampaign');

  return useMemo<boolean>(() => !!(throughReseller || throughCampaign), [throughReseller, throughCampaign]);
}
